import army11 from "./army_11.jpg";
import army12 from "./army_12.jpg";
import army13 from "./army_13.jpg";
import army21 from "./army_21.jpg";
import army22 from "./army_22.jpg";
import army23 from "./army_23.jpg";
import army31 from "./army_31.jpg";
import army32 from "./army_32.jpg";
import army33 from "./army_33.jpg";
import army41 from "./army_41.jpg";
import army42 from "./army_42.jpg";
import army43 from "./army_43.jpg";
import army51 from "./army_51.jpg";
import army52 from "./army_52.jpg";
import army53 from "./army_53.jpg";
import army61 from "./army_61.jpg";
import army62 from "./army_62.jpg";
import army63 from "./army_63.jpg";
import army71 from "./army_71.jpg";
import army72 from "./army_72.jpg";
import army73 from "./army_73.jpg";
import army91 from "./army_91.jpg";
import army92 from "./army_92.jpg";
import army93 from "./army_93.jpg";
import army111 from "./army_111.jpg";
import army112 from "./army_112.jpg";
import army113 from "./army_113.jpg";
import army121 from "./army_121.jpg";
import army122 from "./army_122.jpg";
import army123 from "./army_123.jpg";
import armyD from "./army_d.png";
import armyS from "./army_s.png";

export const armyUnits: {[keys: string]: any} = {
  army11,
  army12,
  army13,
  army21,
  army22,
  army23,
  army31,
  army32,
  army33,
  army41,
  army42,
  army43,
  army51,
  army52,
  army53,
  army61,
  army62,
  army63,
  army71,
  army72,
  army73,
  army91,
  army92,
  army93,
  army111,
  army112,
  army113,
  army121,
  army122,
  army123,
  armyD,
  armyS
}
